/**
 * Patient portal labels (ENG-647).
 *
 * "Patient" here means the CLINIC'S customer (the person who books), not the
 * clinic org itself. Patient accounts hang 1:1 off the `lead` row — see
 * docs/plans/eng-647-customer-portal.md.
 */
// NOTE: patient sign-in tokens (OTP codes + magic links) are now owned by the
// patient Better Auth instance (`@borradh-workspace/auth/patient`) in its
// `patient_verification` table — the bespoke `patient_account_token` enum and
// its purpose labels were removed with that migration (ENG-647).
/** Field types a clinic can add to a consent-form template. */
export const consentFormFieldTypeLabels = {
    text: 'Short text',
    checkbox: 'Checkbox',
    date: 'Date',
};
export const consentFormFieldTypeValues = Object.keys(consentFormFieldTypeLabels);
/** Lifecycle of one patient's consent-form submission for one appointment. */
export const consentFormSubmissionStatusLabels = {
    pending: 'Pending',
    completed: 'Completed',
};
export const consentFormSubmissionStatusValues = Object.keys(consentFormSubmissionStatusLabels);
/** Who uploaded a patient document. */
export const patientDocumentUploadedByLabels = {
    patient: 'Patient',
    staff: 'Staff',
};
export const patientDocumentUploadedByValues = Object.keys(patientDocumentUploadedByLabels);
//# sourceMappingURL=patient-portal.js.map